'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateIntl = updateIntl;

var _pick = require('lodash/pick');

var _pick2 = _interopRequireDefault(_pick);

var _constants = require('./constants');

var _intlReducer = require('./intlReducer');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ACCEPTABLE_KEYS = Object.keys((0, _intlReducer.initialState)());

function updateIntl() {
  var keys = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return {
    type: _constants.UPDATE_ACTION,
    payload: (0, _pick2.default)(keys, ACCEPTABLE_KEYS)
  };
}

exports.default = updateIntl;


//////////////////
// WEBPACK FOOTER
// ./~/redux-intl-connect/lib/updateIntl.js
// module id = 329
// module chunks = 0